export default __webpack_public_path__ + "static/media/man_in_moon.05f4b3df.jpg";